<script setup lang="ts">
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import ErrorTooltip from "@/components/EditView/ErrorTooltip.vue";
import {ref} from "vue";
import {QInput} from "quasar";
import {focusAndSelectInput} from "@/utils/common/NamaVueWidget.ts";

const props = defineProps<WidgetProps>();
const fieldId = props.field.id!;
const fieldUtil = new FieldWidgetUtil(props.presenter, props.fieldMetaData);

const password = fieldUtil.formattedValue();
const input = ref<QInput>()

function focus() {
  focusAndSelectInput(input);
}

function canReceiveFocus() {
  return !fieldUtil.isFieldDisabled(props.forceEnableField);
}

defineExpose({focus, canReceiveFocus})
</script>

<template>
  <WidgetContainer :field="field"
                   :entityType="presenter.entityType"
                   :isSpanned="isSpanned" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
                   :isFieldRequired="fieldUtil.isFieldRequired()" :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
                   :isInsideComposite="isInsideComposite">
    <template v-slot:widget="{ doNotGoToNextWithEnter }">
      <q-input outlined dense hide-bottom-space
               :readonly="fieldUtil.isFieldDisabled(forceEnableField)"
               :id="fieldId" ref="input"
               type="password"
               autocomplete="off"
               :error="!!props.presenter.fetchFieldErrorMsg(fieldId)"
               class="nama-customize-dense-input nama-focused-input"
               :class="{'nama-field-input-disabled':fieldUtil.isFieldDisabled(forceEnableField),'nama-field-input':!fieldUtil.isFieldDisabled(forceEnableField)}"
               input-class="nama-input-class"
               :model-value="password" @update:model-value="fieldUtil.onPartialUserInput"
               @focus="fieldUtil.onFocus" @blur="fieldUtil.onBlur"
               @keydown.enter="(e)=>{ if (!doNotGoToNextWithEnter) $emit('navigateToNext',{keyboardEvent:e}) }">
        <ErrorTooltip v-if="presenter.fetchFieldErrorMsg(fieldId)" :error-msg="presenter.fetchFieldErrorMsg(fieldId)"/>
      </q-input>
    </template>
  </WidgetContainer>
</template>

<style>

</style>
